// extracted by mini-css-extract-plugin
export default {"datatable":"Datatable_datatable__trx2t"};